import { useMutation } from "@tanstack/react-query";
import {
  updateTasksV2,
  BulkUpdateTaskV2,
} from "@coworker/apprestructured/src/task-management/services/tasks.service";

export const useBulkUpdateTasks = () => {
  return useMutation({
    mutationFn: (tasks: BulkUpdateTaskV2[]) => updateTasksV2({ tasks }),
  });
};
